<template>
  <!-- 用于全局搜索用 -->
  <div>

  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>
